import VerifyCode from '../../../components/Auth/VerifyCode/VerifyCode';

const VerifyCodePage = () => {
  return <VerifyCode />;
};

export default VerifyCodePage;
